export const routes = {
    authentication: '/authentication',
    authenticationSubRoutes: {
        login: 'login',
        newAccount: 'new-account',
        personalInfos: 'personal-infos',
        familyMembers: 'family-members',
        facebookAuthenticationReturnUrl: 'facebook/return',
        googleAuthenticationReturnUrl: 'google/return'
    },
    groupsAndOffers: '/groups-and-offers',
    groupsAndOffersSubRoutes: {
        groupOffers: 'group-offers/:groupId',
        sessionOffers: 'session-offers'
    },
    shoppingCart: '/cart',
    smartCartIcon: '/cart-icon',
    profileIcon: '/profile-icon',
    addToWishlist: '/add-to-wishlist',
    addToWishlistListener: '/add-to-wishlist-listener',
    wishlist: '/wishlist',
    dailyDayCamp: '/daily-day-camp',
    memberships: '/memberships',
    calendar: '/calendar',
    treeView: '/tree-view',
    collapseView: '/collapse-view',
    availability: '/availability'
};
